import { Button as MUIButton, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import React from "react";
import { validAscents } from "../../../constants/propTypesValidation";
import { fadeAscentColor, styledBy } from "../../../utils/styles";
import CircularProgress from "../ProgressBar/CircularProgress";



const useStyle = makeStyles((theme) => ({
    root: {
        ...theme.typography.button,
        backgroundColor: styledBy("ascent", theme.palette.primary),
        color: styledBy("colorAscent", theme.palette.primary),
        textTransform: 'uppercase',
        fontSize: (fontSize) => fontSize,
        padding: '.75rem',
        "&:hover": {
            backgroundColor: styledBy("ascent", theme.palette.primary),
        },
        margin: ({ margin }) => margin
    },
    outlined: {
        ...theme.typography.button,
        color: styledBy("ascent", theme.palette.primary),
        fontSize: (fontSize) => fontSize,
        borderColor: fadeAscentColor(theme, 0.5),
        "&:hover": {
            borderColor: styledBy("ascent", theme.palette.primary),
        },
    },
}));

const Button = ({
    form,
    type,
    className,
    fontSize = 10,
    children,
    ascent = null,
    variant = "contained",
    colorAscent,
    color = "secondary",
    fullWidth = false,
    isLoading = false,
    disabled = false,
    hideLoader = false,
    margin = "",
    ...props
}) => {
    const classes = useStyle({ ascent, fontSize, colorAscent, margin });

    return (
        <MUIButton
            form={form}
            type={type}
            color={color}
            variant={variant}
            fullWidth={fullWidth}
            className={clsx(
                {
                    [classes.root]: variant !== "outlined",
                    [classes.outlined]: variant === "outlined",
                },
                className
            )}
            disabled={isLoading || disabled || false}
            {...props}
        >
            {
                isLoading && !hideLoader && <CircularProgress size='1.2rem' />
            }
            {children}
        </MUIButton>
    );
};

Button.propTypes = {
    ascent: validAscents,
};

export default Button;
